import { GIFT_CARD_TYPE } from './giftcard';
import { giftCardAmount } from './validators';

/**
 * @type {Record<import('../types').GIFT_CARD_FIELDS, string>}
 */
export const INITIAL_VALUES_OLD = {
  giftCardAmount: '',
  giftCardEmailId: '',
  giftCardMessage: '',
  giftCardFromName: '',
  giftCardToName: '',
};

/**
 * @type {Record<GIFT_CARD_TYPE, Partial<Record<import('../types').GIFT_CARD_FIELDS, string>>>}
 */
export const INITIAL_VALUES = {
  [GIFT_CARD_TYPE.BASIC]: {
    giftCardAmount: '',
    giftCardMessage: '',
    giftCardFromName: '',
    giftCardToName: '',
  },
  [GIFT_CARD_TYPE.E_GIFT_CARD]: {
    giftCardAmount: '',
    giftCardEmailId: '',
    giftCardMessage: '',
    giftCardFromName: '',
    giftCardToName: '',
  },
  [GIFT_CARD_TYPE.CONSOLIDATED_MASTER]: {
    giftCardAmount: '',
  },
};

/**
 *
 * @type {Record<GIFT_CARD_TYPE, Record<import('../types').GIFT_CARD_FIELDS, string>>}
 */
export const VALIDATION_SCHEMAS = {
  [GIFT_CARD_TYPE.BASIC]: {
    giftCardAmount: 'giftPrice',
    giftCardEmailId: '',
    giftCardMessage: 'giftMessage',
    giftCardFromName: 'giftToFrom',
    giftCardToName: 'giftToFrom',
  },
  [GIFT_CARD_TYPE.E_GIFT_CARD]: {
    giftCardAmount: 'giftPrice',
    giftCardEmailId: 'email',
    giftCardMessage: 'giftMessage',
    giftCardFromName: 'giftToFrom',
    giftCardToName: 'giftToFrom',
  },
  [GIFT_CARD_TYPE.CONSOLIDATED_MASTER]: {
    giftCardAmount,
    giftCardEmailId: '',
    giftCardMessage: '',
    giftCardFromName: '',
    giftCardToName: '',
  },
};
